import barStachedBar from "assets/images/chart-images/stacked-bar.png";
import table from "assets/images/chart-images/table.png";

const timePeriodList = [
        { id: "DFTPM-BVS01t", name: "stacked-bar", chartImage: barStachedBar, disabled: false },
        { id: "DFTPM-T01t", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "DFTPM-T02t", name: "table", chartImage: table, v2: "Row", disabled: false },
        { id: "DFTPM-T20t", name: "table", chartImage: table, disabled: false },
        { id: "DFTPR#-BVS01t", name: "stacked-bar", chartImage: barStachedBar, disabled: false },
        { id: "DFTPR#-T01t", name: "table", chartImage: table, v2: "Column", disabled: false },
        { id: "DFTPR#-T02t", name: "table", chartImage: table, v2: "Row", disabled: false },
        { id: "DFTPR#-T20t", name: "table", chartImage: table, disabled: false },
];

export default timePeriodList;
